import React, { useEffect, useRef, useState } from 'react'
import brandingConfig from '../../../../../config/brandingConfig'
import { useIntl } from 'react-intl'
import GDPR from './assets/img/GDPR.svg'
import HIPAA from './assets/img/HIPAA.svg'
import ISO from './assets/img/ISO.svg'
import AICPAA from './assets/img/AICPAA.svg'
import HeroImage from '../../../../../media/RecordsKeeperAuthLandingPage/landing-page-hero.png'
import starElement from './assets/img/star-element.svg'
import Benefits from '../../../../../media/RecordsKeeperAuthLandingPage/benefits-recordskeeper.png'
import IconQuote from '../../../../../media/images/auth/icons/ic-quote.svg'
import { Autoplay, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Outlet } from 'react-router-dom'
import '../styles/layout.scss'
import '../styles/auth-swiper.scss'
import AuthFloatingButton from './AuthFloatingButton'

const RecordsKeeperAuthLandingPage = ({ data }: any) => {
  const { formatMessage } = useIntl()
  const defaultImage = '/media/testimonials/generic.png'
  const secondDivRef = useRef<HTMLDivElement>(null)
  const scrollToDiv = () => {
    if (secondDivRef.current) {
      secondDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  const [fontSize, setFontSize] = useState('25px');
  const [lineHeight, setLineHeight] = useState('25px');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setFontSize('32px');
        setLineHeight('44px');
      } else {
        setFontSize('32px');
        setLineHeight('44px');
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Call once to set initial font size

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <AuthFloatingButton scrollToDiv={scrollToDiv} />
      <div
        className='col-md-8 h-md-100 order-md-1 order-2 adjuster p-0'
        style={{
          overflowY: 'scroll',
          scrollBehavior: 'smooth',
          scrollbarWidth: 'none',
          overflowX: 'hidden',
          background: '#0B1322',
        }}
      >
        {/* Hero Section starts  */}
        <div className='position-relative rk-lp-hero-bg'>
          <div className='row'>
            <div className='col-md-7'>
              <img src={brandingConfig.lightModeLogo} width={240} alt='' className='mt-8 mb-4 mx-8' />
              <div className='mx-8'>
                <h1 className='text-primary' style={{ fontWeight: 600, fontSize, lineHeight }}>
                  {data.header.text1}
                  <p className='fw-medium text-dark' style={{ fontSize: '18px', lineHeight: '24px' }}> {data.header.text2}</p>
                </h1>
              </div>
            </div>

            <div className='col-md-5' style={{ textAlign: 'center' }}>
              <img src={HeroImage} alt='Hero Banner RecordsKeeper.AI' style={{ width: '500px', display: 'inline-block !important' }} />
            </div>
          </div>
          <img src={starElement} alt='Star Element' style={{ position: 'absolute', top: '40px', right: '40px' }} />

          <div className='position-absolute start-0 w-100 waves d-flex flex-column justify-content-center px-6' style={{ bottom: '0' }}>
            <div className='d-flex gap-2 mt-4 justify-content-center justify-content-md-start'>
              <img src={GDPR} alt='' height={30} width={30} />
              <img src={HIPAA} alt='' height={30} width={30} />
              <img src={ISO} alt='' height={30} width={30} />
              <img src={AICPAA} alt='' height={30} width={30} />
            </div>
            <div className='d-flex align-items-end justify-content-between mb-4 mb-md-0'>
              <span
                className='text-center text-md-start px-4 py-2 rounded-pill text-primary font-size-14 mt-4 fw-medium'
                style={{ background: '#4776E624' }}
              >
                {data.header.label}
              </span>
              <div className='d-md-flex d-none flex-column align-items-end '>
                <h1 className='text-white font-size-16 fw-semibold'>
                  {formatMessage({ id: `Start ${data.header.trialDays} Days Free Trial` })}
                </h1>
                <h1 className='text-white font-size-16 fw-semibold'>
                  {formatMessage({ id: 'No Credit Card Required' })}
                </h1>
              </div>
            </div>
          </div>
        </div>
        {/* Hero Section Ends  */}

        {/* Login Form Section Starts  */}
        <div className='p-6 d-block d-sm-none'>
          <div className='w-100 bg-white p-8 rounded-4' ref={secondDivRef}>
            <Outlet />
          </div>
        </div>
        {/* Login Form Section Ends  */}

        {/* Features Section Starts  */}
        <div className='w-100 px-6'>
          <div className='row g-4 mb-4'>
            {data.features.map(
              (
                feature: {
                  imgSrc: string | undefined
                  title: boolean | React.ReactChild | React.ReactFragment | null | undefined
                  desc:
                  | boolean
                  | React.ReactChild
                  | React.ReactFragment
                  | React.ReactPortal
                  | null
                  | undefined
                },
                index: React.Key | null | undefined
              ) => (
                <div className='col-md-4 col-12' key={index}>
                  <div
                    className='d-flex flex-column p-6 rounded-2 h-100'
                    style={{ background: '#111D33' }}
                  >
                    <img src={feature.imgSrc} alt='' height={48} width={48} className='mb-4' />
                    <h1 className='font-size-14 fw-semibold text-white mb-4 lh-base'>{feature.title}</h1>
                    <p className='font-size-12 mb-0 text-muted'>{feature.desc}</p>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
        {/* Features Section Ends  */}

        {/* Savings Section Starts  */}
        <div className='w-100 px-6 mt-20'>
          <h1 className='text-white font-size-20 mb-8'>{data.saving.headerTitle}</h1>

          <div className='d-flex flex-md-row flex-column justify-content-between gap-4'>
            {/* First Column */}
            <div className='d-flex flex-column'>
              <p className='font-size-12 mb-0 text-muted mb-2'>{data.saving.saving1.title}</p>
              <h1 className='text-white mb-0 font-size-32'>{data.saving.saving1.percentage}</h1>
            </div>

            <div className='d-flex flex-column'>
              <p className='font-size-12 mb-0 text-muted mb-2'>{data.saving.saving2.title}</p>
              <h1 className='text-white mb-0 font-size-32'>{data.saving.saving2.percentage}</h1>
            </div>

            {/* Third Column */}
            <div className='text-white pe-md-14'>
              <ul>
                <li className='mb-2 font-size-12'>{data.saving.pointers.point1}</li>
                <li className='mb-2 font-size-12'>{data.saving.pointers.point2}</li>
                <li className='mb-2 font-size-12'> {data.saving.pointers.point3}</li>
              </ul>
            </div>
          </div>
        </div>
        {/* Savings Section Ends  */}

        {/* Benefits Section Starts  */}
        <div className='w-100 px-6 mt-20'>
          <h1 className='text-white font-size-20 mb-8'>{data.benefits.headerTitle}</h1>

          <div className='d-flex flex-md-row flex-column justify-content-md-between align-items-center gap-16'>
            <div className='d-flex justify-content-center align-items-center'>
              <img src={Benefits} alt='' width={300} className='mb-4 mb-md-0' />
            </div>

            <div className='d-flex flex-column gap-4'>
              {data.benefits.benefitsList.map(
                (
                  benefit: {
                    img: string | undefined
                    title:
                    | boolean
                    | React.ReactChild
                    | React.ReactFragment
                    | React.ReactPortal
                    | null
                    | undefined
                    desc:
                    | boolean
                    | React.ReactChild
                    | React.ReactFragment
                    | React.ReactPortal
                    | null
                    | undefined
                  },
                  index: React.Key | null | undefined
                ) => (
                  <div className='d-flex align-items-start gap-2' key={index}>
                    <img src={benefit.img} alt='' height={24} width={24} />
                    <div>
                      <h1 className='font-size-14 text-white'>{benefit.title}</h1>
                      <p className='font-size-12 fw-normal text-muted'>{benefit.desc}</p>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
        {/* Benefits Section Ends  */}

        {/* Testomonial Section Starts  */}
        <div className='w-100 px-6 mt-20'>
          <h2 className='text-white font-size-20 mb-8'>{formatMessage({ id: `What Users Say` })}</h2>
          <div className='pt-4'>
            <Swiper
              breakpoints={{
                1440: {
                  slidesPerView: 3,
                },
                850: {
                  slidesPerView: 2,
                },
                0: {
                  slidesPerView: 1,
                },
              }}
              loop={true}
              // slidesPerView={3}
              spaceBetween={24}
              autoplay={{ delay: 4000 }}
              modules={[Pagination, Autoplay]}
              className='swipertestomonial'
            >
              {data.testimonials.map(
                (
                  review: {
                    msg:
                    | boolean
                    | React.ReactChild
                    | React.ReactFragment
                    | React.ReactPortal
                    | null
                    | undefined
                    userImage: string | undefined
                    username:
                    | boolean
                    | React.ReactChild
                    | React.ReactFragment
                    | React.ReactPortal
                    | null
                    | undefined
                    position:
                    | boolean
                    | React.ReactChild
                    | React.ReactFragment
                    | React.ReactPortal
                    | null
                    | undefined
                  },
                  index: React.Key | null | undefined
                ) => (
                  <SwiperSlide
                    style={
                      brandingConfig.brandName === 'Foundercrate'
                        ? { minHeight: '200px' }
                        : { minHeight: '230px' }
                    }
                  >
                    <div
                      className='lp-testmonial text-start p-5 rounded-2 bg-dark border-0'
                      style={
                        brandingConfig.brandName === 'Foundercrate'
                          ? { position: 'relative', paddingTop: '40px', minHeight: '170px' }
                          : { position: 'relative', paddingTop: '40px', minHeight: '200px' }
                      }
                    >
                      <img
                        src={IconQuote}
                        alt=''
                        className='lp-quote-icon'
                        style={{ position: 'absolute', top: '-20px' }}
                      />
                      <div className='mt-6'>
                        <div key={index}>
                          <p className='text-light fs-7'>{review.msg}</p>
                        </div>
                        <div className='d-flex gap-2 mt-8'>
                          <img
                            className='lp-profile-image'
                            src={
                              review.userImage && review.userImage ? review.userImage : defaultImage
                            }
                            alt='testimonial of user'
                          />
                          <div>
                            <h1 className='text-light fs-6 m-0'>{review.username}</h1>
                            <p className='text-muted fs-7 m-0 mt-1'>{review.position}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                )
              )}
            </Swiper>
          </div>
        </div>
        {/* Testomonial Section Ends  */}

        {/* FAq Section Starts  */}
        <div className='w-100 px-6 mt-20 mb-8'>
          <h2 className='text-white font-size-20 mb-8'>
            {formatMessage({ id: `Frequently Asked Questions` })}
          </h2>
          <div className='faqs'>
            <div className='accordion lp-accordion' id='accordionExample'>
              {data.faqs.map(
                (faqs: { title: any; desc: any }, index: React.Key | null | undefined) => {
                  const uniqueId = `collapse-${index}`
                  const isFirstItem = index === 0
                  return (
                    <div key={index} className='accordion-item bg-dark lp-ac-item mb-3 w-100'>
                      <h2 className='accordion-header' id={`heading-${index}`}>
                        <button
                          className='accordion-button bg-dark text-light fs-5 fw-normal'
                          type='button'
                          data-bs-toggle='collapse'
                          data-bs-target={`#${uniqueId}`}
                          aria-expanded={isFirstItem ? 'true' : 'false'}
                          aria-controls={uniqueId}
                        >
                          {formatMessage({ id: faqs.title })}
                        </button>
                      </h2>
                      <div
                        id={uniqueId}
                        className={`accordion-collapse collapse ${isFirstItem ? 'show' : ''}`}
                        aria-labelledby={`heading-${index}`}
                        data-bs-parent='#accordionExample'
                      >
                        <div className='accordion-body text-muted'>
                          <p>{formatMessage({ id: faqs.desc })}</p>
                        </div>
                      </div>
                    </div>
                  )
                }
              )}
            </div>
          </div>
        </div>
        {/* FAq Section Ends  */}
      </div>
    </>
  )
}

export default RecordsKeeperAuthLandingPage
